/**
 * ServicesService
 * Service for the ServicesController (microservice registry operations)
 * Route: api/services
 * NOTE: This is different from SystemService which uses api/system
 */
import { BaseService } from '../base/BaseService';
export class ServicesService extends BaseService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? ServicesService.DEFAULT_SERVICE_PATH,
            basePath: ServicesService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
    async getAllServices() {
        const endpoint = this.getEndpoint('', '');
        const url = this.buildUrl(endpoint);
        const response = await this.http.get(url);
        return response.data ?? [];
    }
    async getService(id) {
        const endpoint = this.getEndpoint('by-id', `${id}`);
        const url = this.buildUrl(endpoint);
        const response = await this.http.get(url);
        return response.data ?? null;
    }
    async getServicesByType(serviceType) {
        const endpoint = this.getEndpoint('by-type', `by-type/${serviceType}`);
        const url = this.buildUrl(endpoint);
        const response = await this.http.get(url);
        return response.data ?? [];
    }
    async getActiveServices() {
        const endpoint = this.getEndpoint('active', 'active');
        const url = this.buildUrl(endpoint);
        const response = await this.http.get(url);
        return response.data ?? [];
    }
    async registerService(service) {
        const endpoint = this.getEndpoint('register', '');
        const url = this.buildUrl(endpoint);
        const response = await this.http.post(url, service);
        if (!response.data) {
            throw new Error('No data returned from registerService');
        }
        return response.data;
    }
    async updateService(id, service) {
        const endpoint = this.getEndpoint('update', `${id}`);
        const url = this.buildUrl(endpoint);
        await this.http.put(url, service);
    }
    async updateServiceStatus(id, request) {
        const endpoint = this.getEndpoint('status', `${id}/status`);
        const url = this.buildUrl(endpoint);
        await this.http.patch(url, request);
    }
    async deleteService(id) {
        const endpoint = this.getEndpoint('delete', `${id}`);
        const url = this.buildUrl(endpoint);
        await this.http.delete(url);
    }
}
ServicesService.DEFAULT_SERVICE_PATH = 'system';
ServicesService.BASE_PATH = 'api/services';
//# sourceMappingURL=ServicesService.js.map